import axiosInstance from '../components/utils/axios/axiosInstance';
import {
  SHARE_PLACE_DONE,
  GET_USER_PLACES_DONE,
  GET_SPOTS_DONE,
  GET_SPOTS_LOT_DONE,
  ADD_SPOT_DONE,
  EDIT_SPOT_DONE,
  DELETE_SPOT_DONE
} from './constantsActions';

function sharePlaceDone(data) {
  return {
    type: SHARE_PLACE_DONE,
    payload: data
  };
}

function getUserPlacesDone(data) {
  return {
    type: GET_USER_PLACES_DONE,
    payload: data
  };
}

function getAllSpotsDone(data) {
  return {
    type: GET_SPOTS_DONE,
    payload: data
  };
}

function getSpotsByLotDone(data) {
  return {
    type: GET_SPOTS_LOT_DONE,
    payload: data
  };
}

function addSpotDone(data) {
  return {
    type: ADD_SPOT_DONE,
    payload: data
  };
}

function editSpotDone(data) {
  return {
    type: EDIT_SPOT_DONE,
    payload: data
  };
}

function deleteSpotDone(id) {
  return {
    type: DELETE_SPOT_DONE,
    payload: id
  };
}

export function sharePlace(data) {
  return async (dispatch, getState) => {
    const { id: userId } = getState().auth;
    const { data: resData } = await axiosInstance.post(
      `/api/parkingSpot/sharePlace`,
      {
        dateFrom: data.dateFrom,
        dateTo: data.dateTo,
        permUserId: userId,
        placeId: data.spotId
      }
    );

    dispatch(sharePlaceDone(resData));
    return resData;
  };
}

export function getAllSpots() {
  return async (dispatch) => {
    const { data: resData } = await axiosInstance.get(`/api/parkingSpot/all`);

    dispatch(getAllSpotsDone(resData));
    return resData;
  };
}

export function getSpotsByLot(lotId) {
  return async (dispatch) => {
    const { data: resData } = await axiosInstance.get(
      `/api/parkingSpot/findByParkingLotId`,
      {
        params: {
          id: lotId
        }
      }
    );

    dispatch(getSpotsByLotDone(resData));
    return resData;
  };
}

export function getUserPlaces() {
  return async (dispatch, getState) => {
    const { id: userId } = getState().auth;
    const { data: resData } = await axiosInstance.get(
      `/api/parkingSpot/getUserPlaces`,
      {
        params: {
          id: userId
        }
      }
    );

    dispatch(getUserPlacesDone(resData));
    return resData;
  };
}

export function addSpot(spot) {
  return async (dispatch) => {
    const { data } = await axiosInstance.post(
      `/api/parkingSpot/save`,
      {
        active: true,
        floor: spot.floor,
        place: spot.place
      },
      {
        params: {
          parkingLotId: spot.lot,
          permanentUserId: spot.owner
        }
      }
    );

    dispatch(
      addSpotDone({
        ...data,
        ...{
          permanentUserId: spot.owner
        }
      })
    );
  };
}

export function editSpot(spot) {
  return async (dispatch) => {
    const { data } = await axiosInstance.post(
      `/api/parkingSpot/save`,
      {
        active: true,
        floor: spot.floor,
        id: spot.id,
        place: spot.place
      },
      {
        params: {
          parkingLotId: spot.lot,
          permanentUserId: spot.owner
        }
      }
    );

    dispatch(
      editSpotDone({
        ...data,
        ...{
          permanentUserId: spot.owner
        }
      })
    );
  };
}

export function deleteSpot(id) {
  return async (dispatch) => {
    await axiosInstance.post(
      `/api/parkingSpot/delete`,
      {},
      {
        params: { id }
      }
    );

    dispatch(deleteSpotDone(id));
  };
}
